import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { SwitchStoreStatic } from "./SwitchStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const SwitchDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SwitchStore: SwitchStoreStatic = new SwitchStoreStatic();
